/** Canonical unified_bookings.source values for Manual / platform exports. */

export const AIRBNB_EXPORT_SOURCE = 'AirBnB Export';
export const VRBO_EXPORT_SOURCE = 'VRBO Export';
export const MANUAL_SOURCE = 'Manual';
export const ICAL_SOURCE = 'iCal';

export const MANUAL_OR_EXPORT_SOURCES = [MANUAL_SOURCE, AIRBNB_EXPORT_SOURCE, VRBO_EXPORT_SOURCE] as const;

export function isManualOrExportSource(source?: string | null): boolean {
  const s = String(source || '').trim();
  return s === MANUAL_SOURCE || s === AIRBNB_EXPORT_SOURCE || s === VRBO_EXPORT_SOURCE;
}

export function isExportSource(source?: string | null): boolean {
  const s = String(source || '').trim();
  return s === AIRBNB_EXPORT_SOURCE || s === VRBO_EXPORT_SOURCE;
}
